<template>
  <div>
    <div class="mt-3">
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'today'"
        :color="currentFilter == 'today' ? 'primary' : 'grey'"
        small
        @click="changeDate('today')"
        >{{ $t('today') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'this_month'"
        :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_month')"
        >{{ $t('this month') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'this_year'"
        :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_year')"
        >{{ $t('this year') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_month'"
        :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_month')"
        >{{ $t('last 30 days') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'last_365_day'"
        :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_365_day')"
        >{{ $t('last 365 days') }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outline="currentFilter != 'custom_date'"
        :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
        small
        @click="changeDate('custom_date')"
        >{{ $t('Custom Date') }}</v-btn
      >
    </div>
    <div class v-if="currentFilter == 'custom_date'">
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1">
          <span class="dashboard_datepicker">
            {{ $t('from') }}:
            <v-menu
              v-model="showStartDate"
              full-width
              :close-on-content-click="false"
              min-width="290px"
              ref="showStartDate"
              max-width="290px"
              color="primary"
            >
              <template v-slot:activator="{ on }">
                <div class="form-control">
                  <input
                    v-model="selectedDate.start"
                    type="text"
                    :placeholder="$t('from')"
                    readonly
                    v-on="on"
                  />
                </div>
              </template>
              <v-date-picker
                color="primary"
                v-model="selectedDate.start"
                @input="onSelectedStartDate"
              ></v-date-picker>
            </v-menu>
          </span>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <span class="dashboard_datepicker" style="margin-bottom: 10px;">
            {{ $t('to') }}:
            <v-menu
              v-model="showEndDate"
              full-width
              :close-on-content-click="false"
              min-width="290px"
              ref="showEndDate"
              max-width="290px"
              color="primary"
            >
              <template v-slot:activator="{ on }">
                <div class="form-control">
                  <input
                    v-model="selectedDate.end"
                    type="text"
                    :placeholder="$t('from')"
                    readonly
                    v-on="on"
                  />
                </div>
              </template>
              <v-date-picker
                color="primary"
                v-model="selectedDate.end"
                @input="onSelectedEndDate"
              ></v-date-picker>
            </v-menu>
          </span>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      default: undefined
    },
    defaultFilter: {
      default: 'this_month'
    }
  },
  components: {},
  data: function() {
    return {
      selectedDate: this.value,
      currentFilter: this.defaultFilter,
      showStartDate: false,
      showEndDate: false
    }
  },
  methods: {
    changeDate: function(value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().format('YYYY-MM-DD')
          vm.selectedDate.end = moment().format('YYYY-MM-DD')
          vm.$emit('onSelected', vm.selectedDate)
          vm.$emit('input', vm.selectedDate)
          break

        case 'last_month':
          vm.selectedDate.start = moment()
            .subtract(1, 'months')
            .format('YYYY-MM-DD')
          vm.selectedDate.end = moment().format('YYYY-MM-DD')
          vm.$emit('onSelected', vm.selectedDate)
          vm.$emit('input', vm.selectedDate)
          break

        case 'this_month':
          vm.selectedDate.start = moment()
            .startOf('month')
            .format('YYYY-MM-DD')
          vm.selectedDate.end = moment()
            .endOf('month')
            .format('YYYY-MM-DD')
          vm.$emit('onSelected', vm.selectedDate)
          vm.$emit('input', vm.selectedDate)
          break

        case 'this_year':
          vm.selectedDate.start = moment()
            .startOf('year')
            .format('YYYY-MM-DD')
          vm.selectedDate.end = moment()
            .endOf('year')
            .format('YYYY-MM-DD')
          vm.$emit('onSelected', vm.selectedDate)
          vm.$emit('input', vm.selectedDate)
          break

        case 'last_365_day':
          vm.selectedDate.start = moment()
            .subtract(365, 'days')
            .format('YYYY-MM-DD')
          vm.selectedDate.end = moment().format('YYYY-MM-DD')
          vm.$emit('onSelected', vm.selectedDate)
          vm.$emit('input', vm.selectedDate)
          break

        case 'custom_date':
          break
      }
    },
    onSelectedStartDate: function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      vm.selectedDate.start = value
      vm.showStartDate = false
      vm.$emit('onSelected', vm.selectedDate)
      vm.$emit('input', vm.selectedDate)
    },
    onSelectedEndDate: function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      vm.selectedDate.end = value
      vm.showEndDate = false
      vm.$emit('onSelected', vm.selectedDate)
      vm.$emit('input', vm.selectedDate)
    }
  },
  watch: {
    value: function(newVal) {
      this.selectedDate = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DateFilter.vue